import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';

import Base from '../../components/base/Base';
import CareerSelector from '../../components/careerSelector/CareerSelector';
import { CareerStatus } from '../../components/careerSelector/academicInformationTypes';
import { CareerSelectorConsumer } from '../../components/careerSelector/parts/CareerSelectorProvider';
import DisplayError from '../../components/info/DisplayError';
import TopBar from '../../components/topBar/TopBar';
import DegreeProcess from './parts/DegreeProcess';
import DegreeProcessLoader from './parts/DegreeProcessLoader';
import { TranslationsKeys } from '../../locales/translations';

export default function DegreeProcesses() {
  const { t } = useTranslation(TranslationsKeys.DEGREE_POOCESSES_MAIN);

  const texts = useMemo(() => {
    return {
      title: t(`title`),
      subtitle: t(`subtitle`),
      description: t(`description`),
      noActivities: t(`noActivities`),
      regularInfo: {
        title: t(`regularInfo.title`),
        body: t(`regularInfo.body`),
      },
      titulationPayment: {
        title: t(`titulationPayment.title`),
        body: t(`titulationPayment.body`),
        paymentStatuses: {
          pending: t(`titulationPayment.paymentStatuses.pending`),
          paid: t(`titulationPayment.paymentStatuses.paid`),
        },
        table: {
          headers: {
            concept: t(`titulationPayment.table.headers.concept`),
            amount: t(`titulationPayment.table.headers.amount`),
            paymentDate: t(`titulationPayment.table.headers.paymentDate`),
            status: t(`titulationPayment.table.headers.status`),
            action: t(`titulationPayment.table.headers.action`),
          },
          values: {
            concept: t(`titulationPayment.table.values.concept`),
            button: t(`titulationPayment.table.values.button`),
          },
        },
      },
    };
  }, [t]);

  return (
    <Base>
      <TopBar title={texts.title} />
      <Card className="p-4 mx-3">
        <CareerSelector
          allowedStatus={[
            CareerStatus.Regular,
            CareerStatus.Graduate,
            CareerStatus.Titled,
          ]}
        >
          <Row>
            <Col>
              <h2 className="fs-20 fw-600 text-primary text-uppercase">
                {texts.subtitle}
              </h2>
              <p className="fs-16 text-medium mb-4">{texts.description}</p>
            </Col>
          </Row>
          <CareerSelectorConsumer>
            {({ selectedCareer }) => (
              <>
                {[CareerStatus.Graduate, CareerStatus.Titled].includes(
                  selectedCareer.status,
                ) ? (
                  <DegreeProcessLoader
                    studyPlanEnrollmentId={selectedCareer.studyPlanEnrollmentId}
                  >
                    {({ data, refresh }) => (
                      <DegreeProcess
                        studyPlanEnrollmentId={
                          selectedCareer.studyPlanEnrollmentId
                        }
                        summary={data.degreeProcess.summary}
                        activities={data.degreeProcess.activities}
                        documents={data.degreeDocuments}
                        titulationPaymentInfo={data.titulationPaymentInfo}
                        texts={texts}
                        onRefresh={refresh}
                      />
                    )}
                  </DegreeProcessLoader>
                ) : (
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <DisplayError
                      icon="information"
                      title={texts.regularInfo.title}
                      body={texts.regularInfo.body}
                    />
                  </div>
                )}
              </>
            )}
          </CareerSelectorConsumer>
        </CareerSelector>
      </Card>
    </Base>
  );
}
